import Vue from "vue";
import VueI18n from "vue-i18n";

import de from "./locales/de.json";
import en from "./locales/en.json";

Vue.use(VueI18n);

function savedLocale() {
  try {
    const value = localStorage.getItem("locale");
    return value === "de" || value === "en" ? value : null;
  } catch (e) {
    return null;
  }
}

export default new VueI18n({
  locale: savedLocale() || "de",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: {
    en,
    de,
  },
});
